import { gql } from "lib/apolloClient";
import {
  projectFieldsFragment,
  projectFragments,
  studentFragments,
} from "./StudentPortfolioInsightsFragments";
import { userNameFragment } from "modules/CommonFragments";

export const getStudentPortfolioInsightsProjectsQuery = gql`
  query getStudentProjectPortfolioInsightsProjects(
    $id: ID!
    $filters: PlannerFieldFilter
    $projectFilters: ProjectFilter
  ) {
    node(id: $id, type: STUDENT_PROJECT_PORTFOLIO) {
      ... on StudentProjectPortfolio {
        id
        student {
          ...studentInfo
        }
        projects(filters: $projectFilters) {
          totalCount
          edges {
            node {
              ...portfolioProjectInfo
              ...projectFieldsDetails
            }
          }
        }
      }
    }
  }
  ${projectFragments.portfolioProjectInfoFragment}
  ${projectFieldsFragment.projectFieldsDetails}
  ${studentFragments.studentInfoFragment},
`;

export const getLearningOutcomesWithEvidencesInsightsQuery = gql`
  query getLearningOutcomesWithEvidencesInsights(
    $id: ID!
    $plannerElementEvidenceFilters: PlannerElementsEvidenceFilter!
    $isServiceAsAction: Boolean!
  ) {
    node(id: $id, type: STUDENT_PROJECT_PORTFOLIO) {
      ... on StudentProjectPortfolio {
        id
        student {
          ...studentInfo
        }
        plannerElementEvidences(filters: $plannerElementEvidenceFilters) {
          id
          ibPYPElementRatings(
            filters: { orderBy: CREATED_AT, orderByDirection: DESC }
          ) {
            id
            createdByV2 {
              ...userNameFields
              profileImage
            }
            academicCriteriaSet {
              id
              label
              criteriaType
            }
            createdAt
            academicCriteriaValue {
              id
              label
              abbreviation
              color
            }
          }
          projects {
            totalCount
            edges {
              node {
                ...portfolioProjectInfo
              }
            }
          }
          plannerElementNode {
            id
            label
            subText
            metadata
          }
          evidence {
            totalCount
          }
          isAchieved
          academicYear @include(if: $isServiceAsAction) {
            id
          }
          grade {
            id
            name
          }
        }
      }
    }
  }
  ${projectFragments.portfolioProjectInfoFragment}
  ${studentFragments.studentInfoFragment}
  ${userNameFragment}
`;
